export const preparePhoneNumberForCall = (phone: string) => {
  return phone.replace(/\D/g, '').replace(/^996/, '0')
}
